module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.row.group_list), function(item) {
    return _c('el-tab-pane', {
      attrs: {
        "label": item.name,
        "name": item.name
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "huiyi-items-wrap"
  }, _vm._l((_vm.groupRow.list), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "huiyi-items-li"
    }, [_c('div', {
      staticClass: "train-items-top show-two-row items-top1",
      style: ('background-image: linear-gradient(to right, #' +
        item.color[0] +
        ' , #' +
        item.color[1] +
        ');')
    }, [(item.type_name) ? _c('div', {
      staticClass: "huiyi-type-tip"
    }, [_vm._v("\n              " + _vm._s(item.type_name) + "\n            ")]) : _c('div', {
      staticClass: "huiyi-type-tip"
    }, [_vm._v("会议")]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(item.date_str))])]), _vm._v(" "), _c('div', {
      staticClass: "sai-info-box",
      staticStyle: {
        "flex": "1"
      }
    }, [_c('p', {
      staticClass: "sai-title show-two-row"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "sai-info"
    }, [(item.is_pass) ? _c('el-tag', {
      attrs: {
        "type": "warning"
      }
    }, [_vm._v("结束")]) : _c('el-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v("进行中")])], 1)]), _vm._v(" "), _c('el-row', [_c('el-button', {
      attrs: {
        "type": "primary",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.apply(item)
        }
      }
    }, [_vm._v("进入\n            ")])], 1)], 1)
  }), 0), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7994874e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiList.vue
// module id = 1530
// module chunks = 0